module.exports = __webpack_public_path__ + "static/media/gutgereift_landing1-min.7e48c0d9.jpg";